export default "__VITE_ASSET__DlpIC24$__"